import { Box, Text, Checkbox } from "@chakra-ui/react";
import ContabilizacaoTable from "../ContabilizacaoTable";
import { Flex } from "@chakra-ui/layout";
import { Control, UseFormSetValue } from "react-hook-form";
import RowTableContasBancarias from "./RowTableContasBancarias";
import { useMemo } from "react";
import Field from "components/Input/Field/index";
import { RowTable } from "./RowTableContasBancarias";
import { ExportacaoContabilForm } from "features/exportacao-contabil/typings";
import { Empty } from "antd";

export default function FormContasBancarias({
  form,
  control,
  setValue,
  loading,
}: {
  form: ExportacaoContabilForm;
  control: Control<ExportacaoContabilForm, any>;
  setValue: UseFormSetValue<ExportacaoContabilForm>;
  loading?: boolean;
}) {
  const selectedContasIds = form.contasBancarias
    .filter((conta) => conta.selected)
    .map((conta) => conta.id);

  const contasBancarias = form?.contasBancarias;

  const allContasIds = useMemo(
    () => contasBancarias?.map((conta: any) => conta.id!) ?? [],
    [contasBancarias]
  );

  const isInderteminate =
    selectedContasIds.length > 0 &&
    selectedContasIds.length < allContasIds.length;

  const isCheckedAll =
    !!selectedContasIds.length &&
    selectedContasIds.length === allContasIds.length;

  const selectAll = () => {
    if (isCheckedAll) {
      setValue(
        "contasBancarias",
        contasBancarias?.map((conta) => ({
          id: conta.id,
          selected: false,
          codigoIntegracao: conta.codigoIntegracao,
          nome: conta.nome,
        }))
      );
    } else {
      setValue(
        "contasBancarias",
        contasBancarias?.map((conta) => ({
          id: conta.id,
          selected: true,
          codigoIntegracao: conta.codigoIntegracao,
          nome: conta.nome,
        }))
      );
    }
  };

  if (!contasBancarias?.length && !loading) {
    return <Empty description="Nenhuma conta bancária para exportar" />;
  }

  return (
    <Box>
      <Text mb={8}>
        Selecione as contas bancárias e as contas contábeis que você deseja
        exportar para seu sistema contábil.
      </Text>
      <ContabilizacaoTable
        headerTable={
          <Flex w="100%">
            <Flex flex={4} fontWeight="medium" gap={2}>
              <Checkbox
                onChange={() => selectAll()}
                isChecked={isCheckedAll}
                isIndeterminate={isInderteminate}
              />
              Contas bancárias
            </Flex>
            <Flex flex={2} fontWeight="medium">
              Código reduzido
            </Flex>
          </Flex>
        }
        rowTable={
          <Box w="100%">
            {contasBancarias?.map((conta, index) => (
              <RowTableContasBancarias
                key={conta.id}
                control={control}
                conta={conta}
                index={index}
                form={form}
              />
            ))}
            {selectedContasIds.length === 1 ? (
              <RowTable>
                <Box>
                  <Text fontWeight="medium" mb={2}>
                    Conta transitória para transferências
                  </Text>
                  <Flex>
                    <Flex flex={4} gap={2}>
                      <Text>
                        Existem transferências que a conta de origem ou de
                        destino não foi selecionada para exportação. Defina uma
                        conta contábil transitória para receber e ajustar estes
                        lançamentos
                      </Text>
                    </Flex>
                    <Flex flex={2} fontWeight="medium">
                      <Field
                        control={control}
                        shouldUnregister
                        name="contaTrasitoriaTransferencia"
                        rules={{
                          required: true,
                        }}
                      />
                    </Flex>
                  </Flex>
                </Box>
              </RowTable>
            ) : null}
          </Box>
        }
      />
    </Box>
  );
}
